module.exports = __webpack_public_path__ + "static/media/credit-card-icon.2c96f435.svg";